<template>
	<form class="optimization-ai-answer" action="javascript:;">
		<h4>知识库优化</h4>
		<div class="table">
			<ul>
				<li>问题：</li>
				<li>{{ optimizationAi.clientMsg }}</li>
			</ul>
			<ul>
				<li>回答：</li>
				<li>
					<textarea class="textarea" v-model="optimizationAi.aiMsg"></textarea>
				</li>
			</ul>
		</div>
		<div class="optimization-footer">
			<a class="close-btn" href="javascript:;" @click="$store.commit('changeShowOptimizationAi', false)">取消</a>
			<a class="save-btn" href="javascript:;" @click="save">保存</a>
		</div>
	</form>
</template>

<script>
export default {
	name: 'optimizationAiAnswerTpl',
	data () {
		return {}
	},
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		},
		optimizationAi () {
			return this.$store.state.optimizationAi;
		}
	},
	methods: {
		// 保存修改
		save () {
			var self = this,
				data = {
					serviceType: self.currentShop.serviceType,
					msgMapping: self.optimizationAi
				};

			self.$axios.post(API_ROOT.url + '/AISettingsApi.markAIMsgMapping', data).then(result => {
				if (result.status) {
					if (self.optimizationAi.sessionId == data.msgMapping.sessionId) {
						self.$store.commit('changeShowOptimizationAi', false);
					}
					self.$alert('优化AI智能辅助成功');
				} else {
					self.$alert('优化AI智能辅助失败，失败原因：' + result.msg);
				}
			}, response => {
				self.$alert('优化AI智能辅助失败，错误码(' + response + ')');
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/aside/optimizationAiAnswerTpl.vue